import React from "react";

const SideArtIcon = ({ className }) => (
  <svg className={className} viewBox="0 0 240 172" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <rect x="44" y="26" width="116" height="138" rx="12" fill="#DCE8FD" />
    <rect x="60" y="14" width="116" height="138" rx="12" fill="#FFFFFF" stroke="#C7D9FB" strokeWidth="1.5" />
    <rect x="76" y="34" width="76" height="9" rx="4.5" fill="#2563EB" />
    <rect x="76" y="52" width="84" height="6" rx="3" fill="#C7D9FB" />
    <rect x="76" y="66" width="64" height="6" rx="3" fill="#C7D9FB" />
    <rect x="76" y="80" width="84" height="6" rx="3" fill="#E2EAF8" />
    <rect x="76" y="94" width="48" height="6" rx="3" fill="#E2EAF8" />
    <circle cx="178" cy="124" r="27" fill="#2563EB" />
    <path
      d="M166 124l8 8 16-16"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="3.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M52 96l16-6 16 6v18c0 10-8 15-16 19-8-4-16-9-16-19V96z" fill="#1D4ED8" />
    <path
      d="M60 105l5 5 10-10"
      fill="none"
      stroke="#FFFFFF"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default SideArtIcon;
